import {Component, OnInit} from '@angular/core';
import {MatDialog, MatSnackBar} from '@angular/material';
import { Router, ActivatedRoute } from '@angular/router';

import {FuseTranslationLoaderService} from '../../../core/services/translation-loader.service';
import {ErrorResponse} from '../../../data/model/errorResponse';
import { LogEntry } from '../../../data/model/log.entry';
import { LogEntriesDataManager } from '../../../data/log.entries.datamanager';
import {OrganisationsDataManager} from '../../../data/organisations.datamanager';
import {ConfirmDialogComponent} from '../dialogs/confirm/confirm.dialog.component';
import { LogEntryDetailDialogComponent } from './detail/detail.dialog.component';

import {locale as english} from './i18n/en';
import {locale as turkish} from './i18n/tr';

@Component({
    selector: 'log-entries',
    templateUrl: './log.entries.component.html',
    styleUrls: ['./log.entries.component.scss']
})
export class LogEntriesComponent implements OnInit {
    _id: string;
    rows: LogEntry[];

    constructor(
        private route: ActivatedRoute,
        private dialog: MatDialog, private snackbar: MatSnackBar,
        private logEntriesDataManager: LogEntriesDataManager,
        private organisationsDataManager: OrganisationsDataManager,
        public snackBar: MatSnackBar,
        private translationLoader: FuseTranslationLoaderService) {
            this.translationLoader.loadTranslations(english, turkish);
            this._id = this.route.snapshot.paramMap.get('id');
    }

    ngOnInit() {
        this.logEntriesDataManager.getAllByUserId(this._id, 100).subscribe(response => {
            this.rows = response;
        }, err => {
            this.showError(err.json());
            console.log(err);
        });
    }

    openDetails(rowIndex: number) {
        const logEntry: LogEntry = this.rows[rowIndex];

        const dialogRef = this.dialog.open(LogEntryDetailDialogComponent, {
            height: '830px',
            width: '800px',
            data: {
                logEntry: logEntry
            }
        });

        dialogRef.afterClosed().subscribe(result => {
            if (result !== null && result !== undefined) {
                if (typeof result === 'string') {
                    this.showMessage(result);
                    this.ngOnInit();
                } else {
                    this.showError(result);
                }
            }
        });
    }

    showMessage(message: string) {
        this.snackBar.open(message, null, {duration: 5000});
    }

    showError(message: ErrorResponse) {
        if (message.errors !== null && message.errors !== undefined &&
            message.errors.length > 0) {
            this.snackBar.open(message.errors[0].message, null, {duration: 10000});
        } else {
            this.snackBar.open('Unknown error occured', null, {duration: 10000});
        }
    }
}


// WEBPACK FOOTER //
// /tmp/build_f0fbff5b/src/app/main/content/log.entries/log.entries.component.ts